// extracted by mini-css-extract-plugin
export default {"oneTouchOnMobile":"InteractiveObject_oneTouchOnMobile__Q313v","interactive":"InteractiveObject_interactive__+Rcni","waveBorder":"InteractiveObject_waveBorder__P8Kew"};